module.exports = __webpack_public_path__ + "static/img/index_video.73f0677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_video.jpg
// module id = CpY7
// module chunks = 1